import jwtDecode from 'jwt-decode';
import axios from './axios';

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  // TODO: check refreshToken
  return decoded.exp > currentTime;
};

const setSession = (accessToken, refreshToken) => {
  // TODO: set refreshToken
  if (accessToken) {
    localStorage.setItem('managerAccessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('managerAccessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };
  